export default "__VITE_ASSET__Bx061q2w__"